<template>
    <div class="forgot-password form-con">
        <div class="wrapper">
            <form autocomplete="off" @submit.prevent="submit">
                <div class="input-group-wrapper">
                    <div class="form-group">
                        <label>{{ 'Enter Email' | translate }}</label>
                        <div class="input-wrapper">
                          <svg height="24" width="24" class="t-icon mail icon-right"></svg>
                          <input class="form-control" type="text" :placeholder="'Your email address' | translate" v-model="email.val">
                        </div>
                        <form-notification v-if="email.error_msg" :message="email.error_msg" />
                    </div>
                </div>
                <form-notification v-if="success_msg" :message="success_msg" type="success" />
                <div class="form-group mb-0">
                    <div class="btn-wrapper">
                        <button class="btn btn-orange w-100" :disabled="btn_submit_disabled">
                            <span>{{ 'Confirm' | translate }}</span>
                            <i class="fa fa-spinner fa-pulse" v-if="btn_submit_disabled"></i>
                        </button>
                    </div>
                </div>
                <!-- <div class="form-group">
                    <div class="btn-wrapper">
                        <button class="btn btn-white-orange" @click.prevent="$router.push({ name: 'home' })">
                            <span>{{ 'REGISTER' | translate }}</span>
                        </button>
                    </div>
                </div> -->
            </form>
        </div>
    </div>
</template>

<script>
    import SvgMessage from '@theme-views/common/SvgIcon/Icons/Message'
    import FormNotification from '@theme-views/common/FormNotification'
    import ForgotPassword from '@views/public/pages/Login/ForgotPassPopUp/forgot_password'

    export default {
        mixins: [ForgotPassword],
        components: {
          SvgMessage,
          FormNotification,
        },
        data() {
          return {
            cdn_url: window.APP_CONFIG.CDN_URL
          }
        },
    }
</script>

<style lang="scss">
.forgot-password {
  .form-group {
    margin-bottom: 16px;
    > label {
        margin-bottom: 8px;
        display: flex;
        font-size: 20px;
        color: #797979;
        @media #{$tablet-portrait} {
          font-size: 16px;
        }
    }
  }

  .input-wrapper {
    .icon-right {
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 14px;
      background-color: #53a7d6;
      z-index: 3;
    }
  }
}
</style>
